import { createContext } from 'react'
import { DEFAULT_CART } from '../../../constants'

const CartContext = createContext({
    ...DEFAULT_CART,
    loading: true,
    add: () => {},
    update: () => {},
    remove: () => {},
    get: () => {},
    exists: () => {},
    clear: () => {},
    reset: () => {},
    setShipping: () => {}
})

export { CartContext }
